// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MmMgX_pQ7lgiDLQJnDBg {
	display: flex;
	flex-direction: column;
}
.KdynfA1HN1puUaH1tMld {
	align-items: center;
	color: rgba(0, 0, 0, 0.5);
	display: flex;
	font-size: 16px;
	justify-content: space-between;
	letter-spacing: -0.06em;
	line-height: 28px;
	margin-bottom: 12px;
}
.wmDv825WXsz7LMKTRBZT {
	color: var(--black);
}
.wxGst9hTlYkE7RLb1g3A {
	align-items: center;
	background: none;
	border: none;
	color: var(--black);
	cursor: pointer;
	display: flex;
	font-size: 16px;
	letter-spacing: -0.06em;
	line-height: 28px;
	outline: none;
}
.Eux9vkgW_Q55vQLMisXv {
	height: 16px;
	margin-left: 4px;
	width: 16px;
}
.rdq9hTLhLHdozsPeNtY3 {
	transform: rotate(180deg);
}
@media (max-width: 767px) {
.EN_V_jah6leuD4lKybiA {
		margin-bottom: 22px;
}
	}
@media (max-width: 767px) {
.H3Uc8dJeCnAD_cdDMLAo {
		margin-bottom: 12px;
}
	}
`, "",{"version":3,"sources":["webpack://./src/components/ExpiresDate/ExpiresDate.pcss"],"names":[],"mappings":"AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,aAAa;CACb,eAAe;CACf,8BAA8B;CAC9B,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,aAAa;AACd;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,WAAW;AACZ;AAEA;CACC,yBAAyB;AAC1B;AAGC;AADD;EAEE,mBAAmB;AAErB;CADC;AAIA;AADD;EAEE,mBAAmB;AAErB;CADC","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.title {\n\talign-items: center;\n\tcolor: rgba(0, 0, 0, 0.5);\n\tdisplay: flex;\n\tfont-size: 16px;\n\tjustify-content: space-between;\n\tletter-spacing: -0.06em;\n\tline-height: 28px;\n\tmargin-bottom: 12px;\n}\n\n.value {\n\tcolor: var(--black);\n}\n\n.advanceModeButton {\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: var(--black);\n\tcursor: pointer;\n\tdisplay: flex;\n\tfont-size: 16px;\n\tletter-spacing: -0.06em;\n\tline-height: 28px;\n\toutline: none;\n}\n\n.chevron {\n\theight: 16px;\n\tmargin-left: 4px;\n\twidth: 16px;\n}\n\n.advance {\n\ttransform: rotate(180deg);\n}\n\n.advanceMode {\n\t@media (--mobile) {\n\t\tmargin-bottom: 22px;\n\t}\n}\n\n.simpleMode {\n\t@media (--mobile) {\n\t\tmargin-bottom: 12px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MmMgX_pQ7lgiDLQJnDBg`,
	"title": `KdynfA1HN1puUaH1tMld`,
	"value": `wmDv825WXsz7LMKTRBZT`,
	"advanceModeButton": `wxGst9hTlYkE7RLb1g3A`,
	"chevron": `Eux9vkgW_Q55vQLMisXv`,
	"advance": `rdq9hTLhLHdozsPeNtY3`,
	"advanceMode": `EN_V_jah6leuD4lKybiA`,
	"simpleMode": `H3Uc8dJeCnAD_cdDMLAo`
};
export default ___CSS_LOADER_EXPORT___;
